import { TableGrid } from "@jugl-web/ui-kit";
import React, { useMemo } from "react";
import { CRMStatus } from "../../../../../../components/CRMStatusPill";
import { DomainTableRowData } from "./types";
import { useDomainTableColumns } from "./hooks/useDomainTableColumns";

export const DomainTable: React.FC<{
  displayEmail: string;
  forwardingStatus: CRMStatus;
  domainAuthStatus: CRMStatus | null;
  onForwardingSetupClick: () => void;
  onDomainAuthSetupClick: () => void;
}> = ({
  displayEmail,
  forwardingStatus,
  domainAuthStatus,
  onForwardingSetupClick,
  onDomainAuthSetupClick,
}) => {
  const columns = useDomainTableColumns({
    onForwardingSetupClick,
    onDomainAuthSetupClick,
  });

  const data = useMemo<DomainTableRowData[]>(
    () => [
      {
        id: "domain-row",
        displayEmail,
        forwardingStatus,
        domainAuthStatus,
      },
    ],
    [displayEmail, domainAuthStatus, forwardingStatus]
  );

  return (
    <div className="overflow-hidden rounded-xl border border-solid border-[#EEF2F5]">
      <TableGrid
        id="email-domain"
        variant="grid"
        inline
        data={data}
        columns={columns}
      />
    </div>
  );
};
